<template>
  <div class="makecode">
    <!-- <a-row type="flex" justify="space-between" style="margin-bottom: 0px"> -->
    <a-button type="primary" @click="backBefor()"
      ><a-icon type="left-circle"
    /></a-button>

    <a-form :form="form" @submit="handleSubmit">
      <a-form-item
        v-bind="formItemLayout"
        extra="不选择则是大分类,最高三个层级"
      >
        <span slot="label">
          父级专栏&nbsp;
          <a-icon type="exclamation-circle" />
        </span>
        <a-cascader
          v-decorator="['parentId']"
          :field-names="{
            value: 'id',
            label: 'sortName',
            children: 'children',
          }"
          change-on-select
          :options="options"
          :display-render="displayRender"
          expand-trigger="hover"
          placeholder="选择归属分类"
          @change="onChange"
        />
        <!-- <a-input v-decorator="['parentId']" /> -->
      </a-form-item>

      <a-form-item v-bind="formItemLayout">
        <span slot="label">
          专栏名称&nbsp;
          <a-tooltip title="专栏名称">
            <a-icon type="menu" />
          </a-tooltip>
        </span>
        <a-input
          v-decorator="[
            'sortName',
            {
              rules: [
                {
                  required: true,
                  message: '请输入专栏名称!',
                  whitespace: true,
                },
              ],
            },
          ]"
        />
      </a-form-item>

      <a-form-item v-bind="formItemLayout">
        <span slot="label">
          专栏别名&nbsp;
          <a-tooltip title="专栏别名"> </a-tooltip>
        </span>
        <a-input v-decorator="['sortAlias']" />
      </a-form-item>

      <a-form-item
        v-bind="formItemLayout"
        extra="明确专栏关键点,作用点，目的！"
      >
        <span slot="label">
          关键字&nbsp;
          <a-tooltip title="关键字"> </a-tooltip>
        </span>
        <a-input
          v-decorator="[
            'sortKeyword',
            {
              rules: [
                {
                  required: true,
                  message: '请输入关键字!',
                  whitespace: true,
                },
              ],
            },
          ]"
        />
      </a-form-item>

      <a-form-item v-bind="formItemLayout" extra="明确专栏作用,专栏说明！">
        <span slot="label">
          专栏描述&nbsp;
          <a-tooltip title="专栏描述"> </a-tooltip>
        </span>
        <a-input
          v-decorator="[
            'sortDescribe',
            {
              rules: [
                {
                  required: true,
                  message: '请输入分类描述!',
                  whitespace: true,
                },
              ],
            },
          ]"
        />
      </a-form-item>
      <!-- <a-form-item
        v-bind="formItemLayout"
        label="操作密码"
        extra="您当前登录的账号内部密码"
      >
        <a-row :gutter="3">
          <a-col :span="12">
            <a-input-password
              placeholder="操作密码"
              autocomplete
              v-decorator="[
                'captcha',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入您的内部密码！',
                    },
                  ],
                },
              ]"
            />
          </a-col>
        </a-row>
      </a-form-item> -->
      <!-- <a-form-item v-bind="formItemLayout" hidden>
        <a-input
          v-decorator="[
            'token',
            { initialValue: this.$store.state.index.token },
          ]"
        />
      </a-form-item> -->
      <a-form-item v-bind="tailFormItemLayout">
        <a-switch
          v-decorator="[
            'sortDisabled',
            {
              type: Boolean,
              valuePropName: 'checked',
              initialValue: true,
            },
          ]"
        >
          <a-icon slot="checkedChildren" type="check" />
          <a-icon slot="unCheckedChildren" type="close" />
        </a-switch>
        <span>是否公开显示</span>
        <!-- <a-checkbox>  </a-checkbox> -->
      </a-form-item>
      <a-form-item v-bind="tailFormItemLayout">
        <a-button
          type="primary"
          icon="check"
          :loading="iconLoading"
          html-type="submit"
        >
          提交
        </a-button>
      </a-form-item>
    </a-form>
    <!-- </a-row> -->
  </div>
</template>

<script>
export default {
  name: "addstory",
  data() {
    return {
      iconLoading: false,
      confirmDirty: false,
      /**
       * 父级分了id
       */
      sortParentId: "",
      // residences: [],
      /**
       * 分类数据
       */
      options: [{}],
      autoCompleteResult: [],

      //表单布局
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 8 },
        },
      },
      tailFormItemLayout: {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0,
          },
          sm: {
            span: 16,
            offset: 8,
          },
        },
      },
    };
  },

  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "register" });
  },
  mounted() {
    this.init();
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.iconLoading = true;
      let $this = this;
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          if ($this.sortParentId) {
            values.parentId = $this.sortParentId;
          }
          this.$post("/vr/netuser/sort/add", values)
            .then(function (response) {
              if (response.code != 1) {
                $this.iconLoading = false;
                $this.$message.error(response.msg, 5);
                return;
              }
              $this.$message.success("添加" + values.sortName + "分类成功", 3);
              $this.iconLoading = false;
              $this.backBefor();
            })
            .catch(function (error) {
              console.log(error);
              $this.iconLoading = false;
            });
        } else {
          $this.iconLoading = false;
        }
      });
    },
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },

    init() {
      this.$get("/vr/netuser/sort/select")
        .then((response) => {
          if (response.code != 1) {
            this.$message.error("服务器繁忙", 5);
          }
          this.options = response.data;
          console.log(response.data);
          console.log(this.options + "--------------");
        })
        .catch((error) => {
          this.$message.error(error.data, 5);
          console.log(error);
        });
    },

    /**
     * 选择分类
     */
    onChange(value) {
      this.sortParentId = value[value.length - 1];
    },
    displayRender({ labels }) {
      return labels[labels.length - 1];
    },
  },
};
</script>

<style lang="less" scoped>
.makecode {
  padding: 10px;
  background-color: rgb(255, 255, 255);
}
</style>


// WEBPACK FOOTER //
// src/components/user/usercolumn/sort/addstory.vue